import {useStores} from '../stores/useStores';

import "./Auction/styles.css";

import { observer } from "mobx-react-lite";
import { useEffect, useState } from 'react';
import CardStore from 'src/stores/CardStore';

import NumberFormat from 'react-number-format';

import TokenChooser from './TokenChooser';
import { ASSET_ID, tokenInfo } from 'src/constants/common';

import {ReactComponent as MiniPuzzleIcon} from '../assets/icons/miniPuzzleIcon.svg';
import {ReactComponent as UsdnIcon} from '../assets/tokens/xtn.svg';
import {ReactComponent as EggIcon} from '../assets/tokens/EGG.svg';
import {ReactComponent as UsdtIcon} from '../assets/tokens/USDT.svg';
import {ReactComponent as UsdcIcon} from '../assets/tokens/usdc.svg';
import {ReactComponent as WavesIcon} from '../assets/tokens/waves-logo.svg';
import {ReactComponent as PeteIcon} from '../assets/tokens/pete.svg';

import {ReactComponent as InfoIcon} from '../assets/icons/info.svg';
import { Link } from 'react-router-dom';

type AssetType = ASSET_ID.PUZZLE | ASSET_ID.USDN | ASSET_ID.EGG | ASSET_ID.WAVES | ASSET_ID.USDT | ASSET_ID.USDC | ASSET_ID.USDT_WX | ASSET_ID.USDC_WX;

export interface IBidParams {
    key: string;
    owner: string;
    amount: number;
    assetId: AssetType;
    usdnPrice: number|string;
    usdtPrice: number|string;
}

interface IAuctionOptions {
    nftData: CardStore;
    bidsCountChaned?: (n: number) => void;
    preloadData?: IBidParams[];
}

export default observer(function(props: IAuctionOptions) {
    const { accountStore, walletStore } = useStores();

    const [selectedKey, setSelectedKey] = useState<any>(ASSET_ID.PUZZLE);
    const [amount, setAmount] = useState<number>();

    const [isUpdating, setIsUpdating] = useState<boolean>(false);
    const [updated, setUpdated] = useState<number>(0);

    const [bids, setBids] = useState<IBidParams[]|null>([]);

    let isUserOwner = false;
    if (props.nftData?.seller) {
        isUserOwner = accountStore.address === props.nftData.seller;
    }
    if (props.nftData?.owner) {
        isUserOwner = true;
    }

    useEffect(() => {
        if (updated > 0 || !props.preloadData) {
            setIsUpdating(true);
            walletStore.loadAuction(props.nftData.assetId).then((data) => {
                setBids(data);
                props.bidsCountChaned?.(data.length);
            }).finally(() => {
                setIsUpdating(false);
            })
        }
        return () => {
            // setBids(null);
        };
    }, [updated]);

    const basePrice = ((amount || 0) as number * accountStore.rootStore.usdtPrices[selectedKey]);

    return (
        <div className='nftMarketplace-auction'>
            {
                accountStore.address !== props.nftData.seller ? 
                    <div className='nftMarketplace-auction__addBid'>
                        <div className='nftMarketplace-auction__inputBlock'>
                            <NumberFormat
                                className='nftMarketplace-card__input'
                                displayType='input'
                                value={amount || ''}
                                placeholder='Offer price'
                                thousandSeparator={true}
                                onValueChange={(values) => {
                                    const { value } = values;
                                    setAmount(parseFloat(value));
                                }}
                            />
                            <TokenChooser
                                className='nftMarketplace-auction__select'
                                selected={selectedKey}
                                selectFn={(key: string) => {
                                    setSelectedKey(key);
                                }} />
                            <button
                                disabled={!amount}
                                className={'nftMarketplace-card__button nftMarketplace-card__button_auction' + (!amount ? ' nftMarketplace-card__button_disabled' : '')}
                                title='Accept'
                                onClick={() => {
                                    const price = ((amount || 0) * tokenInfo[selectedKey].decimals) + '';
                                    props.nftData.placeBid(selectedKey, price, () => {
                                        setUpdated(updated + 1);
                                        setAmount(0);
                                    })
                                }}>
                                Add offer
                            </button>
                        </div>
                        <div className='nftMarketplace-card__fee'>
                            <div>
                                <div>
                                    <NumberFormat
                                        className='nftMarketplace-card__feeValue'
                                        displayType='text'
                                        decimalScale={2}
                                        value={(amount || 0)}
                                        thousandSeparator={true} />
                                    &nbsp;
                                    {tokenInfo[selectedKey].title}
                                    &nbsp;
                                    <NumberFormat
                                        className='nftMarketplace-card__feeValue'
                                        displayType='text'
                                        prefix='~ $'
                                        value={basePrice}
                                        decimalScale={2}
                                        title="USD"
                                        thousandSeparator={true} />
                                </div>
                            </div>
                        </div>
                    </div> : ''
            }
            <div className='nftMarketplace-auction__tableWrap'>
                <div className='nftMarketplace-auction__table'>
                    {
                        (bids?.length ? bids : props.preloadData)?.map((item) => {
                            return <div className='nftMarketplace-auction__tableRow' key={item.key}>
                                        <div className='nftMarketplace-auction__address'>
                                            <Link to={`/address/${item.owner}`} title={item.owner}>{item.owner?.substring(3, 0)}...{item.owner?.substring(item.owner.length - 3)}</Link>
                                            {accountStore.address === item.owner ? <div className='nftMarketplace-auction__ownerLabel'>You</div> : ''}
                                        </div>
                                        <div className='nftMarketplace-auction__table-Pirce'>
                                            <NumberFormat
                                                displayType='text'
                                                value={(item.amount / tokenInfo[item.assetId].decimals as number)}
                                                thousandSeparator={true}
                                            />&nbsp;
                                            {item.assetId === ASSET_ID.PUZZLE ?
                                                <MiniPuzzleIcon style={{width: '20px', height: '20px'}} title="Puzzle"/> : ''}
                                            {item.assetId === ASSET_ID.USDN ?
                                                <UsdnIcon style={{width: '24px', height: '20px'}} title="XTN"/> : ''}
                                            {props.nftData.buyOutAssetId === ASSET_ID.PETE ?
                                                <PeteIcon style={{width: '24px', height: '20px'}} title="PETE"/> : ''}
                                            {item.assetId === ASSET_ID.WAVES ?
                                                <WavesIcon style={{width: '18px', height: '18px'}} title="Waves"/> : ''}
                                            {item.assetId === ASSET_ID.EGG ?
                                                <EggIcon style={{width: '24px', height: '24px'}} title="Egg"/> : ''}
                                            {item.assetId === ASSET_ID.USDT ?
                                                <UsdtIcon style={{width: '24px', height: '24px'}} title="USDT PPT"/> : ''}
                                            {item.assetId === ASSET_ID.USDC ?
                                                <UsdcIcon style={{width: '24px', height: '24px'}} title="USDC PPT"/> : ''}
                                            {item.assetId === ASSET_ID.USDT_WX ?
                                                <UsdtIcon style={{width: '24px', height: '24px'}} title="USDT WX"/> : ''}
                                            {item.assetId === ASSET_ID.USDC_WX ?
                                                <UsdcIcon style={{width: '24px', height: '24px'}} title="USDC WX"/> : ''}&nbsp;
                                            {
                                                walletStore.rootStore.usdtPrices[item.assetId] ?
                                                <NumberFormat
                                                    className='nftMarketplace-auction__table-PirceUSDN'
                                                    displayType='text'
                                                    prefix='~ $'
                                                    value={(item.usdtPrice as number).toFixed(2)}
                                                    thousandSeparator={true} /> : ''
                                            }
                                        </div>
                                        <div className='nftMarketplace-auction__actions'>
                                            {
                                                isUserOwner ?
                                                    <a href="#"
                                                        className='nftMarketplace-auction__link nftMarketplace-auction__link_accept'
                                                        onClick={() => {
                                                            props.nftData.acceptBid(item.key, () => {setUpdated(updated + 1)});
                                                        }}>Accept</a> : ''
                                            }
                                            {
                                                accountStore.address === item.owner ?
                                                    <a href="#"
                                                        className='nftMarketplace-auction__link nftMarketplace-auction__link_cancel'
                                                        onClick={() => {
                                                            props.nftData.cancelBid(item.key, () => {setUpdated(updated + 1)});
                                                        }}>Cancel</a> : ''
                                            }
                                        </div>
                                    </div>
                        })
                    }
                    {
                        !bids?.length && !props.preloadData?.length && !isUpdating ? <div className='nftMarketplace-auction__empty'>No offers</div> : ''
                    }
                    {
                        !bids?.length && !props.preloadData?.length && isUpdating ? <div className='nftMarketplace-auction__empty'>Updating...</div> : ''
                    }
                </div>
            </div>
        </div>
    );
});